import React from 'react';

import { useBreadcrumbContext } from 'components/shared/Breadcrumb/context/BreadcrumbContext';
import Button from 'components/shared/Button/Button';

const AddPayerModalHeader = ({ requestNewPayerTab, onRequestNewPayer }) => {
  const { step, nextCrumb } = useBreadcrumbContext();

  if (step !== 0) return null;

  const handleRequestNewPayer = () => {
    if (nextCrumb && requestNewPayerTab) {
      nextCrumb(requestNewPayerTab);
      onRequestNewPayer();
    }
  };

  return (
    <Button
      variant="link"
      size="small"
      color="neutral"
      icon="add-square-mono"
      text="Request new payer"
      className="mr-3 h-6"
      onClick={handleRequestNewPayer}
    />
  );
};

export default AddPayerModalHeader;
